import React from 'react';
import { DropdownMenu } from '@edusense/shared-ui-kit';
import { DropdownMenuItem } from '@edusense/shared-ui-kit';
/**
 * 헤더 컴포넌트에서 사용하는 액션 메뉴
 * 
 * 다양한 유형의 액션 메뉴를 지원하며 variant 속성으로 제어합니다.
 */ const HeaderActionMenu = ({ isOpen, onClose, triggerRef, actions = [], position = 'bottom', align = 'end', customRenderActionMenu })=>{
    // 메뉴가 닫혀 있으면 아무것도 렌더링하지 않음
    if (!isOpen) {
        return null;
    }
    // 커스텀 렌더링 함수가 있는 경우 사용
    if (customRenderActionMenu) {
        return customRenderActionMenu();
    }
    // 액션 핸들러 (클릭 후 메뉴 닫기)
    const handleActionClick = (action)=>{
        if (!action.disabled) {
            action.onClick();
            onClose();
        }
    };
    // 액션이 없으면 아무것도 렌더링하지 않음
    if (!actions.length) {
        return null;
    }
    // 범용 액션 메뉴
    return /*#__PURE__*/ React.createElement(DropdownMenu, {
        isOpen: isOpen,
        onClose: onClose,
        triggerRef: triggerRef,
        position: position,
        align: align
    }, actions.map((action, index)=>/*#__PURE__*/ React.createElement(DropdownMenuItem, {
            key: index,
            icon: action.icon,
            onClick: ()=>handleActionClick(action),
            variant: action.variant,
            disabled: action.disabled,
            "data-testid": action.testId
        }, action.label)));
};
export default HeaderActionMenu;
